// extracted by mini-css-extract-plugin
export default {"statusDot":"styles_statusDot__u8Jwd","active":"styles_active__esYJt","small":"styles_small__gc1tW"};